import React, { useState, useEffect } from "react";
import roomBackgrounds from "../assets/roomBackgrounds";
import { useNavigate } from "react-router-dom"; // for redirect

function RegisterForm() {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.backgroundImage = `url(${roomBackgrounds.Default})`;
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundPosition = "center";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";

    return () => {
      document.body.style.backgroundImage = "none";
      document.body.style.background = "black";
    };
  }, []);

  const [form, setForm] = useState({ username: "", email: "", accessCode: "" });
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false); // for styling

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("/api/auth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      if (res.ok) {
        setSuccess(true);
        setMessage("✅ Registered successfully!  Redirecting...");
        setTimeout(() => navigate("/"), 2000); // 👈 redirect after 2s
      } else {
        setSuccess(false);
        setMessage(`❌ ${data.error || "Registration failed"}`);
      }
    } catch (err) {
      setSuccess(false);
      setMessage("⚠️ Server error");
    }
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh'
    }}>
      <form onSubmit={handleRegister} style={{
        textAlign: 'center',
        padding: '2rem',
        border: '1px solid #ccc',
        borderRadius: '10px',
        background: 'rgba(240, 240, 240, 0.7)',
        boxShadow: '0 0 10px rgba(0,0,0,0.1)'
      }}>
        <h2>Register</h2>
        <input name="username" placeholder="Username" onChange={handleChange} required />
        <br />
        <input name="email" placeholder="Email" type="email" onChange={handleChange} required />
        <br />
        <input name="accessCode" placeholder="Password" type="password" onChange={handleChange} required />
        <br />
        <button type="submit">Register</button>
        <p style={{
          marginTop: "1rem",
          fontWeight: success ? "bold" : "normal",
          fontSize: success ? "1.2rem" : "1rem",
          color: success ? "green" : "red"
        }}>
          {message}
        </p>
      </form>
    </div>
  );
}

export default RegisterForm;
